'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getIsTwoFactorAuthOptionEnabled = require('./shared/getIsTwoFactorAuthOptionEnabled.js');
var getFromConfigQuery = require('./shared/getFromConfigQuery.js');
var getFeatureEnable = require('./shared/getFeatureEnable.js');
var signUpFormConfig = require('./ukgc/sign-up-form-config.js');
var signUpFormConfig$1 = require('./default/sign-up-form-config.js');



exports.isTwoFactorAuthOptionEnabled = getIsTwoFactorAuthOptionEnabled.isTwoFactorAuthOptionEnabled;
exports.getIbanConfig = getFromConfigQuery.getIbanConfig;
exports.getMailCheckConfig = getFromConfigQuery.getMailCheckConfig;
exports.getMaximumAge = getFromConfigQuery.getMaximumAge;
exports.getMinimumAge = getFromConfigQuery.getMinimumAge;
exports.getPasswordMaxLength = getFromConfigQuery.getPasswordMaxLength;
exports.getPasswordValidationConditions = getFromConfigQuery.getPasswordValidationConditions;
exports.getPersonalIdConfig = getFromConfigQuery.getPersonalIdConfig;
exports.getPhoneConfig = getFromConfigQuery.getPhoneConfig;
exports.getSecurityQuestionsConfig = getFromConfigQuery.getSecurityQuestionsConfig;
exports.getAmendDobHintFeature = getFeatureEnable.getAmendDobHintFeature;
exports.getCollapsibleMarketingPreferencesFeature = getFeatureEnable.getCollapsibleMarketingPreferencesFeature;
exports.getMailCheckFeatureEnabled = getFeatureEnable.getMailCheckFeatureEnabled;
exports.getUnmaskPasswordFeature = getFeatureEnable.getUnmaskPasswordFeature;
exports.UKGCSignupFormConfig = signUpFormConfig.UKGCSignupFormConfig;
exports.defaultSignupFormConfig = signUpFormConfig$1.defaultSignupFormConfig;
